import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;

  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.md};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Thead = styled.thead`
  background-color: ${colors.surfaceContainer};
`;

export const Th = styled.th`
  padding: 16px 24px;
  text-align: left;

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${colors.onSurfaceVariant};
  white-space: nowrap;
`;

export const Tbody = styled.tbody`
  tr {
    border-top: 1px solid ${colors.outlineVariant}30;
    transition: background-color 0.2s;
  }

  tr:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const Td = styled.td`
  padding: 16px 24px;

  font-size: 14px;
  color: ${colors.onSurface};
`;

export const TableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 16px 24px;
  border-top: 1px solid ${colors.outlineVariant}30;
`;

export const PaginationInfo = styled.span`
  font-size: 12px;
  color: ${colors.onSurfaceVariant};
`;

export const EmptyState = styled.div`
  padding: 48px 24px;
  text-align: center;

  font-size: 13px;
  color: ${colors.onSurfaceVariant};
`;
